// Seção reutilizável para listar documentos já anexados a um falecido e permitir anexar novos
import { useState, useEffect, useCallback } from "react";
import Api from "../../services/Api";
import { API_DOCUMENTS_FOLDER } from "../../constants";
import DocumentUploader from "./DocumentUploader";
import OrangeButton from "./OrangeButton";

const sectionTitleStyle = {
  fontFamily: "'DM Sans', sans-serif",
  fontSize: 15,
  fontWeight: 700,
  color: "#555",
  marginBottom: 4,
  marginTop: 8,
};

function FalecidoDocumentsManager({ falecidoId }) {
  const [documentos, setDocumentos] = useState([]);
  const [docFiles, setDocFiles] = useState([]);
  const [docDescricoes, setDocDescricoes] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");

  const loadDocumentos = useCallback(() => {
    if (!falecidoId) return;
    Api.getFalecidoDocumentos(falecidoId)
      .then((docs) => setDocumentos(docs || []))
      .catch(() => {});
  }, [falecidoId]);

  useEffect(() => {
    loadDocumentos();
  }, [loadDocumentos]);

  const handleEnviar = async () => {
    if (!docFiles.length) return;
    setError("");
    setUploading(true);
    try {
      for (let i = 0; i < docFiles.length; i++) {
        const tipo = docDescricoes[i]?.trim() || undefined;
        await Api.uploadFalecidoDoc(falecidoId, docFiles[i], tipo);
      }
      setDocFiles([]);
      setDocDescricoes([]);
      loadDocumentos();
    } catch (e) {
      setError(e.message || "Erro ao enviar documentos.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      <p style={sectionTitleStyle}>Documentos</p>
      <hr style={{ border: "none", borderTop: "1px solid #e0e0e0", marginBottom: 8 }} />

      {documentos.length > 0 && (
        <ul
          style={{
            listStyle: "none",
            padding: 0,
            margin: "0 0 12px",
            display: "flex",
            flexDirection: "column",
            gap: 6,
          }}
        >
          {documentos.map((doc) => (
            <li
              key={doc.id}
              style={{
                background: "#f4f4f4",
                borderRadius: 12,
                padding: "8px 14px",
                fontFamily: "'DM Sans', sans-serif",
                fontSize: 13,
              }}
            >
              <a
                href={`${API_DOCUMENTS_FOLDER}/${doc.arquivo_path}`}
                target="_blank"
                rel="noreferrer"
                style={{ color: "#E8956A", textDecoration: "none" }}
              >
                {doc.tipo || "Documento"}
              </a>
              {doc.descricao && (
                <span style={{ color: "#999", marginLeft: 6 }}>— {doc.descricao}</span>
              )}
            </li>
          ))}
        </ul>
      )}

      <DocumentUploader
        inputId={`falecido-doc-upload-${falecidoId}`}
        files={docFiles}
        onChange={setDocFiles}
        descricoes={docDescricoes}
        onDescricoesChange={setDocDescricoes}
      />

      {docFiles.length > 0 && (
        <div style={{ textAlign: "center", marginTop: 12 }}>
          <OrangeButton onClick={handleEnviar} disabled={uploading}>
            {uploading ? "Enviando..." : "Enviar documentos"}
          </OrangeButton>
        </div>
      )}

      {error && (
        <p
          style={{
            fontFamily: "'DM Sans', sans-serif",
            fontSize: 13,
            color: "#e53935",
            marginTop: 10,
          }}
        >
          {error}
        </p>
      )}
    </div>
  );
}

export default FalecidoDocumentsManager;
